import Model from "@/models/Model"

export default class AConfirmEdit extends Model {
    resource() {
        return "confirm_edit"
    }
}